import React, { useMemo, useState } from "react";

import PropTypes from "prop-types";

import IconButton from "../IconButton";

import { CheckIcon,CopyIcon } from "../../assets/icons";

import "./WPCopyToClipBoard.scss";

const WPCopyToClipboard = ({ text, className, id, disabled = false }) => {
  const [isCopied, setIsCopied] = useState(false);

  const tooltip = useMemo(
    () => (isCopied ? "Copied" : "Click to copy"),
    [isCopied],
  );

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setIsCopied(true);
      window.setTimeout(() => setIsCopied(false), 1000);
    } catch (error) {
      setIsCopied(false);
    }
  };

  return (
    <IconButton
      className={`copy-to-clipboard-icon ${className || ""}`.trim()}
      onClick={handleCopy}
      tooltip={tooltip}
      id={id}
      disabled={disabled}
    >
      {isCopied ? <CheckIcon /> : <CopyIcon />}
    </IconButton>
  );
};

WPCopyToClipboard.propTypes = {
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
  id: PropTypes.string,
  disabled: PropTypes.bool,
};

export default WPCopyToClipboard;
